import { CardPaymentDeclineError } from "common/types";

import Alert from "client/common/components/content/Alert";

type CardPaymentDeclineAlertProps = {
  declineError: CardPaymentDeclineError;
};

const CardPaymentDeclineAlert = ({ declineError }: CardPaymentDeclineAlertProps) => {
  return (
    <Alert variant="danger" shouldScrollOnMount={true}>
      <strong>{declineError.card_decline_description}</strong>
      <p>{declineError.card_decline_next_steps}</p>
    </Alert>
  );
};

export default CardPaymentDeclineAlert;
